
export function toListString(obj, clue = ',', encode = v => v) {
	return Object.keys(obj)
		.map(key => `${key}=${encode(obj[key])}`)
		.join(clue);
}

export function loadScript(url) {
	return new Promise((resolve, reject) => {
		const head = document.head || document.getElementsByTagName('head')[0];
		const script = document.createElement('script');
		script.async = true;
		script.src = url;
		script.setAttribute('rel', 'preconnect');
		script.charset = 'utf-8';

		head.appendChild(script);

		script.onload = resolve;
		script.onerror = reject;
	});
}

export class Defer {
	constructor() {
		this.promise = new Promise((resolve, reject) => {
			this.resolve = resolve;
			this.reject = reject;
		});
	}
}
